import { Alert, List, Typography } from 'antd';
import type { ExtractionWarning } from '@/types/extractedTopic';

const { Text } = Typography;

interface Props {
  warnings: ExtractionWarning[];
}

export function WarningsPanel({ warnings }: Props) {
  if (warnings.length === 0) return null;
  return (
    <Alert
      type="warning"
      showIcon
      message={`${warnings.length} warning${warnings.length === 1 ? '' : 's'} from extraction`}
      description={
        <List
          size="small"
          dataSource={warnings}
          renderItem={(w) => (
            <List.Item style={{ padding: '4px 0' }}>
              <Text code>{w.field}</Text>
              <span style={{ marginLeft: 8 }}>{w.message}</span>
            </List.Item>
          )}
        />
      }
      style={{ marginBottom: 16 }}
    />
  );
}
